import { HttpClient } from '@angular/common/http';
import { Injectable, computed, inject, signal } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../environments/environment';

export interface AccessUser {
  accessId: number;
  userName: string;
  isAdministrator: boolean;
  hasDailyReporting: boolean;
}

@Injectable({ providedIn: 'root' })
export class CurrentUserService {
  private readonly http = inject(HttpClient);
  private readonly userSignal = signal<AccessUser | null>(null);

  readonly user = this.userSignal.asReadonly();
  readonly isAdministrator = computed(
    () => this.userSignal()?.isAdministrator ?? false
  );
  readonly hasDailyReporting = computed(
    () => this.userSignal()?.hasDailyReporting ?? false
  );

  async load(): Promise<void> {
    const user = await firstValueFrom(
      this.http.get<AccessUser>(`${environment.apiBaseUrl}/api/me`)
    );
    this.userSignal.set(user);
  }
}
